// extracted by mini-css-extract-plugin
export default {"loaderBox":"LoaderDefaultImage_loaderBox__29iGo"};